module.exports = __webpack_public_path__ + "img/profile@2x(1).11774d29.png";